import axios from 'axios';
import { API_URL } from './config';

// Abrufen der globalen Einstellungen (Logo, Avatar)
export const fetchGlobalSettings = async () => {
  try {
    const response = await axios.get(`${API_URL}/global-setting?populate=Logo`);
    return response.data;
  } catch (error) {
    console.error('Error fetching global settings');
    return null;
  }
};

// Laden der Stationen (Name, Tastenanzahl)
export const fetchStationData = async () => {
  try {
    const response = await axios.get(`${API_URL}/stations?populate=*`);
    return response.data.data.map(station => ({
      name: station.Name,
      slug: station.Slug,
      buttonCount: station.Tastenanzahl,
    }));
  } catch (error) {
    console.error('Error fetching station data:', error);
    return [];
  }
};
